import React from 'react';
import { AccessibleFakeButton, Avatar, FontIcon, DropdownMenu, IconSeparator, ListItem } from 'react-md';
import { injectIntl, intlShape } from 'react-intl';
import ReactSVG from 'react-svg';
import PropTypes from 'prop-types';

import NavItemLink from './NavItemLink';

import logout from '../icons/logout-variant.svg';
import settings from '../icons/settings.svg';

import frFlag from '../icons/fr.png';
import nlFlag from '../icons/nl.png';
import deFlag from '../icons/de.png';
import usFlag from '../icons/us.png';

const getAccountLabel = (userAttributes) => {
  if (userAttributes.name || userAttributes.family_name) return `${userAttributes.name || ''} ${userAttributes.family_name || ''}`;
  return userAttributes.email || '';
};

const AccountMenu = ({
  intl, handleLogout, userAttributes, className, handleChangeLocale,
}) => {
  const logoutIcon = (<ReactSVG
    path={logout}
    className="svgicon"
  />);

  const menuItems = [
    <NavItemLink key="settings" to="/settings" svgicon={settings} label={intl.formatMessage({ id: 'accountMenu.settings' })} />,
    <ListItem key="logout" leftIcon={logoutIcon} onClick={handleLogout} primaryText={intl.formatMessage({ id: 'accountMenu.logout' })} />,
    {
      primaryText: intl.formatMessage({ id: 'accountMenu.language' }),
      nestedItems: [
        {
          primaryText: intl.formatMessage({ id: 'accountMenu.languageFr' }),
          leftIcon: <img src={frFlag} alt="SwitchFR" />,
          onClick: () => handleChangeLocale('fr'),
        }, {
          primaryText: intl.formatMessage({ id: 'accountMenu.languageNl' }),
          leftIcon: <img src={nlFlag} alt="SwitchNL" />,
          onClick: () => handleChangeLocale('nl'),
        }, {
          primaryText: intl.formatMessage({ id: 'accountMenu.languageDe' }),
          leftIcon: <img src={deFlag} alt="SwitchDE" />,
          onClick: () => handleChangeLocale('de'),
        }, {
          primaryText: intl.formatMessage({ id: 'accountMenu.languageEn' }),
          leftIcon: <img src={usFlag} alt="SwitchEN" />,
          onClick: () => handleChangeLocale('en'),
        }],
    },
  ];


  return (
    <DropdownMenu
      cascading
      className={className}
      id="avatar-dropdown-menu"
      menuItems={menuItems}
      anchor={{
            x: DropdownMenu.HorizontalAnchors.INNER_RIGHT,
            y: DropdownMenu.VerticalAnchors.TOP,
          }}
      simplifiedMenu={false}
    >
      <AccessibleFakeButton
        component={IconSeparator}
        iconBefore
        label={getAccountLabel(userAttributes)}
      >
        <Avatar icon={<FontIcon>person</FontIcon>} />
      </AccessibleFakeButton>
    </DropdownMenu>


  );
};
AccountMenu.propTypes = {
  className: PropTypes.string,
  handleLogout: PropTypes.func,
  userAttributes: PropTypes.object,
  intl: intlShape.isRequired,
  handleChangeLocale: PropTypes.func,
};

export default injectIntl(AccountMenu);



// WEBPACK FOOTER //
// ./src/components/AccountMenu.js